var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "book_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M825.111 102.959H211.456a30.627 30.627 0 0 0-30.673 30.72v797.696c0 16.989 13.73 30.72 30.72 30.72H825.11c16.99 0 30.72-13.731 30.72-30.72V133.632a30.627 30.627 0 0 0-30.72-30.673zm-249.297 69.026h92.067v201.31l-44.59-32.49-47.477 33.979V171.939zm210.944 721.036H249.809V172.032h268.475v284.579c0 3.165.93 6.33 2.885 8.937a15.267 15.267 0 0 0 21.411 3.537l80.338-57.437 78.057 56.972a15.36 15.36 0 0 0 24.343-12.381V171.985h61.3v721.036h.093z"
  })));
};
export default SvgBook;